export default __webpack_public_path__ + "static/media/Package Locker- Package.8224b8bc.jpg";